import { DateFormatPipe } from 'app/pipes/date-format.pipe';

export interface IOnlineReportObject {
  getHTML(): string;
}

export class RafReportObject implements IOnlineReportObject {
  description: string;
  otherTypeDetails: string;
  additionalDetails: string;
  firstName: string;
  subjectData: any[];
  lastName: string;
  line1: any;
  line2: any;
  postcode: string;
  type: string;

  constructor(reportDetails: any) {
    reportDetails = reportDetails || {};
    this.description = reportDetails.description;
    this.otherTypeDetails = reportDetails.otherTypeDetails;
    this.additionalDetails = reportDetails.additionalDetails;
    this.firstName = reportDetails.firstName;
    this.subjectData = reportDetails.subjectData;
    this.lastName = reportDetails.lastName;
    this.line1 = reportDetails.line1;
    this.line2 = reportDetails.line2;
    this.postcode = reportDetails.postcode;
    this.type = reportDetails.type;
  }

  getHTML(): string {
    var detailOnTypeOfFraud: string = '';
    if (this.type == 'Other')
      detailOnTypeOfFraud = `<tr><td class="label">Detail on Type of Fraud:</td><td class="fieldValue">${this?.otherTypeDetails}</td></tr>`;

    var html: string = `<table style="width: 100%">
            <tr>
                <td class="label">Type of Fraud:</td>
                <td class="fieldValue">${this.type}</td>
            </tr>
            ${detailOnTypeOfFraud}
            <tr>
                <td class="label">Description of Fraud:</td>
                <td class="fieldValue">${this.description || ''}</td>
            </tr>
            <tr>
                <td class="label">Subject's First Name:</td>
                <td class="fieldValue">${this.subjectData[0]?.values[0]?.value || ''}</td>
            </tr>
            <tr>
                <td class="label">Subject's Last Name:</td>
                <td class="fieldValue">${this.subjectData[0]?.values[1]?.value || ''}</td>
            </tr>
            <tr>
                <td class="label">Additional Person Details:</td>
                <td class="fieldValue">${this.subjectData[0]?.additionalDetails || ''}</td>
            </tr>
            <tr>
                <td class="label">Address Line One:</td>
                <td class="fieldValue">${this.subjectData[1]?.values[0]?.value || ''}</td>
            </tr>
            <tr>
                <td class="label">Address Line Two:</td>
                <td class="fieldValue">${this.subjectData[1]?.values[1]?.value || ''}</td>
            </tr>

            <tr>
                <td class="label">Postcode:</td>
                <td class="fieldValue">${this.subjectData[1]?.values[2]?.value || ''}</td>
            </tr>
            <tr>
                <td class="label">Additional Address Details:</td>
                <td class="fieldValue">${this.subjectData[1]?.additionalDetails || ''}</td>
            </tr>
            <tr>
                <td class="label">Additional Case Details:</td>
                <td class="fieldValue">${this.additionalDetails || ''}</td>
            </tr>

        </table>`;
    return html;
  }
}
export class FtsuReportObject implements IOnlineReportObject {
  role: string;
  descOfConcerns: string;
  speakingOutcome: string;
  immediateConcern: string;
  anonymityStatus: string;
  subjectData: any[];
  profGroup: string;

  constructor(reportDetails?) {
    reportDetails = reportDetails || {};
    this.role = reportDetails.role;
    this.descOfConcerns = reportDetails.descOfConcerns;
    this.speakingOutcome = reportDetails.speakingOutcome;
    this.immediateConcern = reportDetails.immediateConcern;
    this.anonymityStatus = reportDetails.anonymityStatus;
    this.subjectData = reportDetails.subjectData;
    this.profGroup = reportDetails.profGroup;
  }

  getHTML(): string {
    var anonymityStatusString = '';
    if (this.anonymityStatus == 'c') anonymityStatusString = `<td class="fieldValue">Reported Confidentially</td>`;
    if (this.anonymityStatus == 'r') anonymityStatusString = `<td class="fieldValue">Reported a Concern</td>`;
    if (this.anonymityStatus == 'a') anonymityStatusString = `<td class="fieldValue">Reported Anonymously</td>`;

    var ImmediateConcerns: string = '';
    if (this.immediateConcern === 'true') ImmediateConcerns = 'Yes';
    if (this.immediateConcern === 'false') ImmediateConcerns = 'No';

    var html: string = `<table style="width: 100%">
            <tr>
                <td class="label">Anonymity Status:</td>
                <td class="fieldValue">${anonymityStatusString || ''}</td>
            </tr>
            <tr>
                <td class="label">Role:</td>
                <td class="fieldValue">${this.role || ''}</td>
            </tr>
            <tr>
                <td class="label">Subject's First Name:</td>
                <td class="fieldValue">${this.subjectData[0]?.values[0]?.value || ''}</td>
            </tr>
            <tr>
                <td class="label">Subject's Last Name:</td>
                <td class="fieldValue">${this.subjectData[0]?.values[1]?.value || ''}</td>
            </tr>
            <tr >
                <td class="label">Description of Concern:</td>
                <td class="fieldValue">${this.descOfConcerns || ''}</td>
            </tr>
            <tr>
                <td class="label">Speaking Out Outcome:</td>
                <td class="fieldValue">${this.speakingOutcome || ''}</td>
            </tr>
            <tr>
                <td class="label">Any Immediate Concerns?:</td>
                <td class="fieldValue">${ImmediateConcerns || ''}</td>
            </tr>
            <tr>
                <td class="label">Professional Group:</td>
                <td class="fieldValue">${this.profGroup || ''}</td>
            </tr>
        </table>`;
    return html;
  }
}

export class FacReportReferrer {
  public email: string = '';
  public name: string = '';
  public telephone: string = '';
}

export class FacCustomQuestions {
  public label: string = '';
  public response: string = '';
}

export class FacReportObject implements IOnlineReportObject {
  description: string;
  language: string;
  country: string;
  anonymous: boolean;
  referrer: FacReportReferrer;
  subjectData: any[];
  organisation: string;
  location: any;
  relationship: any;
  person: string;
  role: string;
  department: string;
  reportedBefore: boolean;
  whenReportedDate: Date;
  whoReportedTo: string;
  whatWasTheOutcome: string;
  howAwareOfWrongDoing: string;
  details: string;
  anyWitnesses: boolean;
  howAware: string;
  furtherInformation: string;
  startDate: Date;
  resolution: string;
  customQuestionResponses?: any[];
  callHandlersName?: string;
  equalityMonitoringData: any[];

  constructor(reportDetails: any) {
    reportDetails = reportDetails || {};
    this.details = reportDetails.details;
    this.description = reportDetails.description;
    this.language = reportDetails.language;
    this.country = reportDetails.country;
    this.anonymous = reportDetails.anonymous;
    this.subjectData = reportDetails.subjectData;
    this.organisation = reportDetails.organisation;
    this.location = reportDetails.location;
    this.relationship = reportDetails.relationship;
    this.person = reportDetails.person;
    this.role = reportDetails.role;
    this.department = reportDetails.department;
    this.reportedBefore = reportDetails.reportedBefore;
    this.whenReportedDate = reportDetails.whenReportedDate;
    this.whoReportedTo = reportDetails.whoReportedTo;
    this.whatWasTheOutcome = reportDetails.whatWasTheOutcome;
    this.howAwareOfWrongDoing = reportDetails.howAwareOfWrongDoing;
    this.anyWitnesses = reportDetails.anyWitnesses;
    this.howAware = reportDetails.howAware;
    this.furtherInformation = reportDetails.furtherInformation;
    this.startDate = reportDetails.startDate;
    this.resolution = reportDetails.resolution;
    this.referrer = new FacReportReferrer();
    if (reportDetails.referrer) {
      this.referrer.name = reportDetails.referrer.name || '';
      this.referrer.email = reportDetails.referrer.email || '';
      this.referrer.telephone = reportDetails.referrer.telephone || '';
    }
    if (reportDetails.customQuestionResponses) {
      //if there is a collection of labels -> responses
      this.customQuestionResponses = reportDetails.customQuestionResponses;
    } else {
      this.customQuestionResponses = undefined;
    }
    if (reportDetails.callHandlersName) {
      this.callHandlersName = reportDetails.callHandlersName;
    }
    this.equalityMonitoringData = reportDetails?.equalityMonitoringData;
  }

  getHTML(): string {
    var anyWitnessesString = '';
    var witnessesDetails = '';
    if (this.anyWitnesses === false) anyWitnessesString = 'No';
    if (this.anyWitnesses === true) {
      anyWitnessesString = 'Yes';
      witnessesDetails = `<tr>
                <td class="label">Witness Details:</td>
                <td class="fieldValue">${this.furtherInformation}</td>
            </tr>`;
    }
    var startDateString = new DateFormatPipe('en-GB').transform(this.startDate);
    var whenReportedDateString = new DateFormatPipe('en-GB').transform(this.whenReportedDate);

    var reportedBeforeString = '';
    var reportedBeforeDetails = '';
    if (this.reportedBefore === false) {
      reportedBeforeString = 'No';
    } else {
      reportedBeforeString = 'Yes';
      reportedBeforeDetails = `<tr>
                <td class="label">Reported Date:</td>
                <td class="fieldValue">${whenReportedDateString || ''}</td>
            </tr>
            <tr>
                <td class="label">Reported To:</td>
                <td class="fieldValue">${this.whoReportedTo || ''}</td>
            </tr>
            <tr>
                <td class="label">What was the outcome?:</td>
                <td class="fieldValue">${this.whatWasTheOutcome || ''}</td>
            </tr>`;
    }

    var customQuestionResponseDetails = '';
    var customQuestionResponsesString = '';

    if (this.customQuestionResponses) {
      //iterate through loop, assigning the label and response to the corresponding
      //customQuestionResponseDetails
      for (let i = 0; i < this.customQuestionResponses.length; i++) {
        customQuestionResponseDetails += `<tr>
                <td class="label">${this.customQuestionResponses[i]['label'] || ''}</td>
                <td class="fieldValue">${this.customQuestionResponses[i]['response'] || ''}</td>
            </tr>`;
      }
    } else {
      customQuestionResponsesString = 'No custom questions found attached';
    }

    var callHandlersDetails = '';
    if (this.callHandlersName) {
      callHandlersDetails = `<tr>
                <td class="label">Call Handler's Name:</td>
                <td class="fieldValue"> ${this.callHandlersName || ''}</td>
            </tr>`;
    }

    var reportedAnonymous = '';
    var reportedAnonymousDetails = '';
    if (this.anonymous === false) {
      reportedAnonymous = 'No';
      reportedAnonymousDetails = `<tr>
                <td class="label">Full Name:</td>
                <td class="fieldValue">${this.referrer.name || ''}</td>
            </tr>`;
    } else {
      reportedAnonymous = 'Yes';
    }
    var html: string = `<table style="width: 100%">
            <tr>
                <td class="label">Country:</td>
                <td class="fieldValue">${this.country || ''}</td>
            </tr>
            <tr>
                <td class="label">Report Anonymously:</td>
                <td class="fieldValue">${reportedAnonymous || ''}</td>
            </tr>
            ${reportedAnonymousDetails}
            <tr>
                <td class="label">Email:</td>
                <td class="fieldValue">${this.referrer.email || ''}</td>
            </tr>
              <tr>
                <td class="label">Telephone:</td>
                <td class="fieldValue">${this.referrer.telephone || ''}</td>
            </tr>

            <tr>
                <td class="label">Name of Organisation:</td>
                <td class="fieldValue">${this.organisation || ''}</td>
            </tr>
            <tr>
                <td class="label">Location/Address:</td>
                <td class="fieldValue">${this.location || ''}</td>
            </tr>
            <tr>
                <td class="label">Relationship With Organisation:</td>
                <td class="fieldValue">${this.relationship || ''}</td>
            </tr>
            <tr>
                <td class="label">Reported Person:</td>
                <td class="fieldValue">${this.person || ''}</td>
            </tr>
            <tr>
                <td class="label">Job Role/Title:</td>
                <td class="fieldValue">${this.role || ''}</td>
            </tr>
            <tr>
                <td class="label">Department:</td>
                <td class="fieldValue">${this.department || ''}</td>
            </tr>
            <tr>
                <td class="label">Start Date:</td>
                <td class="fieldValue">${startDateString || ''}</td>
            </tr>
            <tr>
                <td class="label">Reported Before?:</td>
                <td class="fieldValue">${reportedBeforeString || ''}</td>
            </tr>
            ${reportedBeforeDetails}
            <tr>
                <td class="label">How did you become aware of the wrongdoing?:</td>
                <td class="fieldValue">${this.howAwareOfWrongDoing || ''}</td>
            </tr>
            <tr>
                <td class="label">Details Reported:</td>
                <td class="fieldValue">${this.details || ''}</td>
            </tr>
            <tr>
                <td class="label">Were there any witnesses?:</td>
                <td class="fieldValue">${anyWitnessesString || ''}</td>
            </tr>
            ${witnessesDetails}
            <tr>
                <td class="label">Preferred Resolution:</td>
                <td class="fieldValue">${this.resolution || ''}</td>
            </tr>
            <tr>
                <td class="label">How did you become aware of SeeHearSpeakUp?:</td>
                <td class="fieldValue">${this.howAware || ''}</td>
            </tr>
        </table>`;
    return html;
  }
}
